// src/pages/Opciones.js
import React from 'react';
import './Opciones.css';

function Opciones() {
  return (
    <div className="opciones-container">
      <h1>Personalización</h1>
      <p>Aquí puedes personalizar tu experiencia.</p>
      <label>
        Tema de colores:
        <select>
          <option value="default">Predeterminado</option>
          <option value="blue">Azul</option>
          <option value="green">Verde</option>
        </select>
      </label>
    </div>
  );
}

export default Opciones;
